<script>
import {mapState, mapMutations} from "vuex";
import TriviaService from "@/api/services/triviaService";
import DcbService from "@/api/services/dcbService";

export default {
  name: 'PrizesView',
  data() {
    return {
      encryptedMsisdn: null
    }
  },
  computed: {
    ...mapState(['userStats', 'user', 'productId', 'isFreeUser']),
  },
  methods: {
    ...mapMutations(['setUserStats']),
    async getUserStats() {
      const recordsets = await TriviaService.getUserStats(this.user.msisdn, this.productId, this.user.serviceId);

      this.setUserStats(recordsets?.[0]?.[0])
    },
    async encryptMsisdn() {
      let encryptMsisdnResponse = (await DcbService.encryptUserMsisdn(this.user.msisdn)).data;

      this.encryptedMsisdn = encryptMsisdnResponse.encryptedMsisdn;
    },
    async viewCouponStore() {
      await this.encryptMsisdn();
      window.open(`https://voucher-store-staging.mzrhythm.com/?e-msisdn=${this.encryptedMsisdn}&productId=35`, '_self');
    },
    },
  async mounted(){
    await this.getUserStats();
  }
}
</script>

<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-12">

    <div class="d-flex justify-content-between align-items-center col-11 mt-4 ">
      <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"
           class="col-5" alt="logo"/>
      <div class="d-flex flex-column justify-content-center align-items-end col-5">
        <div class="d-flex justify-content-center align-items-center  col-5 gap-2">
          <div class="col-4 mt-2 mb-2 fw-bold coin-size-value">{{ userStats?.TotalCoins }}</div>
          <img src="@/assets/gameplay/coins-medium.png" class="col-8 mt-2 mb-2" alt="coins"/>
        </div>
      </div>
    </div>

    <div class="d-flex mt-4 p-3 justify-content-center yellow-button border col-11" @click="viewCouponStore">VIEW COUPON STORE</div>

    <div class="mt-3 prizes">Prizes</div>
    <div class="info-text blue ">Swipe through to learn how to play</div>
    <div class="info-text blue ">and win with Mzansi Rhythms</div>

    <div class="banner-wrap col-11 mt-2">
      <img class="col-12" :src="isFreeUser ? require('@/assets/prizes/free_user.png') : require('@/assets/prizes/vip_user.png')" alt="prizes"/>

      <template v-if="isFreeUser">
        <div class="banner-heading">
          Win your share of <span class="banner-highlight">R33 000 in coupons</span> every month!
        </div>
        <p class="banner-body">
          Win a share of R33 000 in coupons every month. Upgrade to VIP to better your chances. Let's start playing!
        </p>
      </template>

      <template v-else>
        <div class="banner-heading">
          Your share of <span class="banner-highlight">R33 000 in coupons</span> up for grabs monthly
        </div>
        <p class="banner-body">
          Win your share of R33 000 in coupons every month. Earn coins by answering questions correctly. The more coins you accumulate, the better your chances of winning. Let's start playing!
        </p>
      </template>
    </div>

  </div>

</template>

<style scoped>
.yellow-button{
  font-size: 18px;
  font-weight: 600;
  background: #FFCB05;
  border-radius: 43px;
}

.prizes{
  font-size: 22px;
  font-weight: 600;
}

.blue{
  color: #000F56;
}

.coin-size-value{
  font-size: 20px;
}

/* ---- prizes banner text overlay (text-free artwork underneath) ---- */
.banner-wrap {
  position: relative;
}

.banner-wrap img {
  display: block;
  width: 100%;
}

.banner-heading,
.banner-body {
  position: absolute;
  left: 6%;
  right: 6%;
  margin: 0;
  text-align: left;
  font-family: "Clash Display", sans-serif;
}

.banner-heading {
  color: #5D136D;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
  top: 46%;
}

.banner-body {
  color: #000F56;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  top: 60%;
}

.banner-highlight {
  font-size: 1.2em;
  font-weight: 800;
}

</style>